import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './views/HomePage.vue';
import AMLTrainingDownload from './views/AMLTrainingDownload.vue';
import IntegrityFrameworkDownload from './views/IntegrityFrameworkDownload.vue';

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      title: 'Lessons Learned - Expert Consultants in Financial Crime Compliance'
    }
  },
  {
    path: '/aml-training-guide',
    name: 'AMLTrainingDownload',
    component: AMLTrainingDownload,
    meta: {
      title: 'Role-Based AML Training for UAE LFIs - Lessons Learned'
    }
  },
  {
    path: '/integrity-framework',
    name: 'IntegrityFrameworkDownload',
    component: IntegrityFrameworkDownload,
    meta: {
      title: 'Integrity Activities Benchmarking Framework - Lessons Learned'
    }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

// Update document title on route change
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Lessons Learned';
  next();
});

export default router;
